import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from 'assets/ssc_search.png';
import GDNIcon from 'assets/ssc_gdn.png';
import YoutubeIcon from 'assets/ssc_youtube.png';
import GmailIcon from 'assets/ssc_gmail.png';
import ReferenceCard from './ReferenceCard';
import Styles from './index.module.css';

export default function GoogleDisplayReference({ small }) {
  return (
    <div className={Styles.mainContainer}>
      <ReferenceCard small={small} title="Search 搜尋" src={SearchIcon} />
      <ReferenceCard small={small} title="GDN 網站聯播網" src={GDNIcon} />
      <ReferenceCard small={small} title="YouTube 影片" src={YoutubeIcon} />
      <ReferenceCard small={small} title="Gmail 信箱" src={GmailIcon} />
    </div>
  );
}

GoogleDisplayReference.propTypes = {
  small: PropTypes.bool,
};

GoogleDisplayReference.defaultProps = {
  small: false,
};
